"use strict";

exports.__esModule = true;
exports.IconButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ThemeProvider = require("../../ThemeProvider");
var _Icon = require("../../Elements/Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-props-no-spreading */

const IconButton = props => {
  const {
    id,
    handleClick,
    handleOnChange,
    size,
    clkContainerCssModifier,
    disabled,
    variant,
    icon,
    bsPrefix,
    active,
    analytics
  } = props;
  const prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'ccl__icon-button');
  const activeClass = active ? 'active' : 'noactive';
  const color = variant === 'digital-primary' || variant === 'secondary--inverse' ? 'inverse' : 'interactive';
  const [flag, setFlag] = (0, _react.useState)(false);
  const contents = /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    type: "button",
    onMouseDown: e => {
      handleClick(e);
      if (!flag) {
        handleOnChange(e);
      }
      setFlag(!flag);
    },
    className: `ccl-e-icon-clickable__button 
      ccl-e-icon-clickable__button--${clkContainerCssModifier} 
      ccl-e-icon-clickable__button--${variant} 
      ccl-e-icon-clickable__button--${variant}--${activeClass} 
      ccl-e-icon-clickable__button--size--${size}`,
    "data-nw-action": id,
    "data-analytics": analytics,
    disabled: disabled,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      type: icon,
      color: disabled ? `disabled` : color,
      className: `${prefix}-icon`
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "ccl-e-icon-clickable ccl-e-icon-clickable--iconButton",
    children: contents
  });
};
exports.IconButton = IconButton;
IconButton.defaultProps = {
  id: '',
  handleClick: () => {
    console.log('click');
  },
  handleOnChange: () => {
    console.log('onchage');
  },
  icon: 'add',
  clkContainerCssModifier: 'tool-bar',
  disabled: false,
  variant: 'brandPrimary',
  size: 'large',
  active: false
};